import React, { useEffect, useMemo, useState } from "react";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";
import PageHeader from "pages/components/PageHeader";
import ProjectTable from "pages/components/ProjectTable/ProjectTable";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import Draggable from "react-draggable";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import {
  Accordion,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  IconButton,
  Paper,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function PaperComponent(props) {
  return (
    <Draggable
      handle=".draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], input, textarea, select, button'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function hojeISO() {
  return new Date().toISOString().slice(0, 10);
}

function toISODate(v) {
  if (!v) return "";
  return String(v).slice(0, 10);
}

function normalizarTexto(v) {
  return String(v || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

function obterRegraSomaVendas(catalogos) {
  return (catalogos?.tiposDesafio || []).find((x) => {
    const txt = normalizarTexto(`${x.codigo || ""} ${x.nome || ""}`);
    return txt.includes("soma") && txt.includes("venda");
  });
}

function obterCondicaoQuantidade(catalogos) {
  return (catalogos?.tiposCondicao || []).find((x) => {
    const txt = normalizarTexto(`${x.codigo || ""} ${x.nome || ""}`);
    return txt.includes("qtd") || txt.includes("quantidade");
  });
}

function obterOperadorMaiorIgual(catalogos) {
  return (catalogos?.tiposOperador || []).find((x) => String(x.codigo || "") === ">=");
}

export default function Incentivos() {
  const { showAlert } = useAlert();
  const { temPermissao, userData } = useAuth();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [openAdd, setOpenAdd] = useState(false);
  const [novo, setNovo] = useState({
    nome: "",
    dataini: hojeISO(),
    datafim: hojeISO(),
    reffabricante: "",
    idfuncaoresponsavel: null,
    beneficio_empresa: false,
    obs: "",
  });

  const [openEdit, setOpenEdit] = useState(false);
  const [sel, setSel] = useState(null);

  const [catalogos, setCatalogos] = useState(null);
  const [doc, setDoc] = useState({
    desafios: [],
    desafiosRegras: [],
    materiais: [],
    patamares: [],
    condicoes: [],
    clientesExcluidos: [],
  });
  const [expandedDesafio, setExpandedDesafio] = useState(null);
  const [expandedPatamar, setExpandedPatamar] = useState(null);

  const [openDesafio, setOpenDesafio] = useState(false);
  const [desafioEditId, setDesafioEditId] = useState(0);
  const [novoDesafio, setNovoDesafio] = useState({
    nome: "",
    ordem: 1,
    obs: "",
  });

  const [openMaterial, setOpenMaterial] = useState(false);
  const [materialTargetDesafio, setMaterialTargetDesafio] = useState(null);
  const [novoMaterial, setNovoMaterial] = useState({
    refmaterial: "",
  });

  const [materiaisOptions, setMateriaisOptions] = useState([]);
  const [materialSel, setMaterialSel] = useState(null);

  const [openPatamar, setOpenPatamar] = useState(false);
  const [patamarEditId, setPatamarEditId] = useState(0);
  const [patamarTargetDesafio, setPatamarTargetDesafio] = useState(null);
  const [novoPatamar, setNovoPatamar] = useState({
    ordem: 1,
    descricao: "",
    idtipobeneficio: "",
    beneficio: "",
    beneficio_aplicacao: "FIXO",
    obs: "",
  });

  const [openCondicao, setOpenCondicao] = useState(false);
  const [condicaoEditId, setCondicaoEditId] = useState(0);
  const [condicaoTargetPatamar, setCondicaoTargetPatamar] = useState(null);
  const [condicaoTargetDesafio, setCondicaoTargetDesafio] = useState(null);
  const [novaCondicao, setNovaCondicao] = useState({
    ordem: 1,
    idtipocondicao: "",
    idtipooperador: "",
    valor: "",
    obs: "",
  });

  const [openConfirm, setOpenConfirm] = useState(false);
  const [target, setTarget] = useState(null);
  const [novoEstado, setNovoEstado] = useState(1);

  const [openResultados, setOpenResultados] = useState(false);
  const [resultados, setResultados] = useState([]);

  const [openResultadoDetalhe, setOpenResultadoDetalhe] = useState(false);
  const [resultadoDetalhe, setResultadoDetalhe] = useState([]);
  const [resultadoDetalheTitulo, setResultadoDetalheTitulo] = useState("");

  const carregar = async () => {
    setLoading(true);
    try {
      const [payload, err] = await handleApi(
        api.post("Comercial/SelIncentivos", { incluirInativos: true })
      );

      if (err) {
        showAlert(err, "error");
        return;
      }

      setData(Array.isArray(payload) ? payload : []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const carregarCatalogos = async () => {
    const [payload, err] = await handleApi(api.post("Comercial/SelIncentivosCatalogos", {}));
    if (err) {
      showAlert(err, "error");
      return null;
    }
    setCatalogos(payload || {});
    return payload || {};
  };

  const carregarClientesExcluidos = async (idincentivo) => {
    if (!idincentivo) return [];

    const [payload, err] = await handleApi(
      api.post("Comercial/SelIncentivosClientesExcluidos", { idincentivo })
    );

    if (err) {
      showAlert(err, "error");
      return [];
    }

    return Array.isArray(payload) ? payload : [];
  };

  const abrirEdicao = async (r) => {
    setLoading(true);
    try {
      if (!catalogos) await carregarCatalogos();

      const [payload, err] = await handleApi(api.post("Comercial/ObterIncentivo", { id: r.id }));
      if (err) {
        showAlert(err, "error");
        return;
      }

      const incentivo = payload?.incentivo || r;

      setSel({
        ...incentivo,
        dataini: toISODate(incentivo.dataini),
        datafim: toISODate(incentivo.datafim),
        reffabricante: incentivo.reffabricante || "",
        idfuncaoresponsavel: incentivo.idfuncaoresponsavel || null,
        beneficio_empresa: Boolean(incentivo.beneficio_empresa),
        obs: incentivo.obs || "",
      });

      const clientesExcluidos = await carregarClientesExcluidos(r.id);

      setDoc({
        desafios: Array.isArray(payload?.desafios) ? payload.desafios : [],
        desafiosRegras: Array.isArray(payload?.desafiosRegras) ? payload.desafiosRegras : [],
        materiais: Array.isArray(payload?.materiais) ? payload.materiais : [],
        patamares: Array.isArray(payload?.patamares) ? payload.patamares : [],
        condicoes: Array.isArray(payload?.condicoes) ? payload.condicoes : [],
        clientesExcluidos,
      });

      setExpandedDesafio(null);
      setExpandedPatamar(null);
      setOpenEdit(true);
    } finally {
      setLoading(false);
    }
  };

  const inserir = async () => {
    if (!novo.nome?.trim()) return showAlert("Indica o nome do incentivo.", "warning");
    if (!novo.dataini || !novo.datafim) return showAlert("Indica o período.", "warning");

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/InsIncentivo", {
          nome: novo.nome.trim().toUpperCase(),
          dataini: novo.dataini,
          datafim: novo.datafim,
          reffabricante: novo.reffabricante?.trim() || null,
          idfuncaoresponsavel: novo.idfuncaoresponsavel || null,
          beneficio_empresa: novo.beneficio_empresa ? 1 : 0,
          obs: novo.obs?.trim() || null,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Incentivo criado.", meta?.severity || "success");
      setOpenAdd(false);
      setNovo({
        nome: "",
        dataini: hojeISO(),
        datafim: hojeISO(),
        reffabricante: "",
        idfuncaoresponsavel: null,
        beneficio_empresa: false,
        obs: "",
      });
      await carregar();
    } finally {
      setLoading(false);
    }
  };

  const gravarEdicao = async () => {
    if (!sel?.nome?.trim()) return showAlert("Indica o nome do incentivo.", "warning");
    if (!sel.dataini || !sel.datafim) return showAlert("Indica o período.", "warning");

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/UpdIncentivo", {
          id: sel.id,
          nome: sel.nome.trim().toUpperCase(),
          dataini: sel.dataini,
          datafim: sel.datafim,
          reffabricante: sel.reffabricante?.trim() || null,
          idfuncaoresponsavel: sel.idfuncaoresponsavel || null,
          beneficio_empresa: sel.beneficio_empresa ? 1 : 0,
          obs: sel.obs?.trim() || null,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Incentivo atualizado.", meta?.severity || "success");
      setOpenEdit(false);
      await carregar();
    } finally {
      setLoading(false);
    }
  };

  const criarGrupoRapido = async () => {
    if (!sel?.id) return;

    const ordem = (doc.desafios || []).length + 1;
    const nome = `GRUPO ${ordem}`;
    const cats = catalogos || (await carregarCatalogos()) || {};

    setLoading(true);
    try {
      const [payload, err, meta] = await handleApi(
        api.post("Comercial/InsIncentivoDesafio", {
          idincentivo: sel.id,
          nome,
          ordem,
          obs: null,
        })
      );

      if (err) return showAlert(err, "error");

      const iddesafio = payload?.id || null;
      const regraSoma = obterRegraSomaVendas(cats);

      if (iddesafio && regraSoma?.id) {
        const [_rPayload, rErr] = await handleApi(
          api.post("Comercial/UpdIncentivoDesafioRegras", {
            iddesafio,
            idsregras: [Number(regraSoma.id)],
          })
        );

        if (rErr) return showAlert(rErr, "error");
      }

      showAlert(meta?.message || "Grupo criado.", meta?.severity || "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(iddesafio);
    } finally {
      setLoading(false);
    }
  };

  const gravarDesafio = async () => {
    if (!sel?.id) return;
    if (!novoDesafio.nome?.trim()) return showAlert("Indica o nome do desafio.", "warning");

    const isEdit = Number(desafioEditId || 0) > 0;

    setLoading(true);
    try {
      const [payload, err, meta] = await handleApi(
        api.post(isEdit ? "Comercial/UpdIncentivoDesafio" : "Comercial/InsIncentivoDesafio", {
          id: desafioEditId,
          idincentivo: sel.id,
          nome: novoDesafio.nome.trim().toUpperCase(),
          ordem: Number(novoDesafio.ordem || 1),
          obs: novoDesafio.obs?.trim() || null,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Desafio gravado.", meta?.severity || "success");

      setOpenDesafio(false);
      setDesafioEditId(0);
      setNovoDesafio({ nome: "", ordem: 1, obs: "" });

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(isEdit ? desafioEditId : payload?.id || null);
    } finally {
      setLoading(false);
    }
  };

  const removerDesafio = async (d) => {
    if (!d?.id) return;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/DelIncentivoDesafio", { id: d.id })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Desafio eliminado.", meta?.severity || "success");
      await abrirEdicao({ id: sel.id });
    } finally {
      setLoading(false);
    }
  };

  const toggleRegraDesafio = async (desafio, idtipodesafio, checked) => {
    if (!sel?.id || !desafio?.id) return;

    const atuais = (doc.desafiosRegras || [])
      .filter((r) => Number(r.iddesafio) === Number(desafio.id))
      .map((r) => Number(r.idtipodesafio));

    const idsregras = checked
      ? Array.from(new Set([...atuais, Number(idtipodesafio)]))
      : atuais.filter((id) => Number(id) !== Number(idtipodesafio));

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/UpdIncentivoDesafioRegras", {
          iddesafio: desafio.id,
          idsregras,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Regras atualizadas.", meta?.severity || "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(desafio.id);
    } finally {
      setLoading(false);
    }
  };

  const pesquisarMateriais = async (term) => {
    const texto = String(term || "").trim();

    if (texto.length < 2) {
      setMateriaisOptions([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Comercial/SelIncentivosMateriaisCombo", {
        term: texto,
        reffabricante: sel?.reffabricante || "",
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setMateriaisOptions(Array.isArray(payload) ? payload : []);
  };

  const adicionarMaterial = async () => {
    if (!sel?.id) return;
    if (!materialTargetDesafio?.id) return;

    const refMaterial = materialSel?.ref || novoMaterial.refmaterial;

    if (!refMaterial?.trim()) return showAlert("Seleciona o material.", "warning");

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/InsIncentivoDesafioMaterial", {
          iddesafio: materialTargetDesafio.id,
          refmaterial: refMaterial.trim(),
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Material associado.", meta?.severity || "success");

      setOpenMaterial(false);
      setNovoMaterial({ refmaterial: "" });
      setMaterialSel(null);
      setMateriaisOptions([]);

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(materialTargetDesafio.id);
    } finally {
      setLoading(false);
    }
  };

  const removerMaterial = async (m, iddesafio) => {
    if (!m?.id) return;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/DelIncentivoDesafioMaterial", { id: m.id })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Material removido.", meta?.severity || "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(iddesafio);
    } finally {
      setLoading(false);
    }
  };

  const gravarPatamar = async () => {
    if (!sel?.id) return;
    if (!patamarTargetDesafio?.id) return;
    if (!novoPatamar.idtipobeneficio) return showAlert("Indica o tipo de benefício.", "warning");

    const isEdit = Number(patamarEditId || 0) > 0;

    setLoading(true);
    try {
      const [payload, err, meta] = await handleApi(
        api.post(isEdit ? "Comercial/UpdIncentivoPatamar" : "Comercial/InsIncentivoPatamar", {
          id: patamarEditId,
          iddesafio: patamarTargetDesafio.id,
          ordem: Number(novoPatamar.ordem || 1),
          descricao: novoPatamar.descricao?.trim() || null,
          idtipobeneficio: Number(novoPatamar.idtipobeneficio),
          beneficio: novoPatamar.beneficio?.trim() || null,
          beneficio_aplicacao: novoPatamar.beneficio_aplicacao || "FIXO",
          obs: novoPatamar.obs?.trim() || null,
        })
      );

      if (err) return showAlert(err, "error");

      if (!isEdit && payload?.id) {
        const cats = catalogos || (await carregarCatalogos()) || {};
        const tipoQuantidade = obterCondicaoQuantidade(cats);
        const operadorMaiorIgual = obterOperadorMaiorIgual(cats);

        if (tipoQuantidade?.id && operadorMaiorIgual?.id) {
          const [_cPayload, cErr] = await handleApi(
            api.post("Comercial/InsIncentivoCondicao", {
              idpatamar: payload.id,
              idtipocondicao: Number(tipoQuantidade.id),
              idtipooperador: Number(operadorMaiorIgual.id),
              valor: 1,
              ordem: 1,
              obs: null,
            })
          );

          if (cErr) return showAlert(cErr, "error");
        }
      }

      showAlert(meta?.message || "Patamar gravado.", meta?.severity || "success");

      setOpenPatamar(false);
      setPatamarEditId(0);
      setNovoPatamar({
        ordem: 1,
        descricao: "",
        idtipobeneficio: "",
        beneficio: "",
        beneficio_aplicacao: "FIXO",
        obs: "",
      });

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(patamarTargetDesafio.id);
      setExpandedPatamar(isEdit ? patamarEditId : payload?.id || null);
    } finally {
      setLoading(false);
    }
  };

  const removerPatamar = async (p, iddesafio) => {
    if (!p?.id) return;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/DelIncentivoPatamar", { id: p.id })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Patamar eliminado.", meta?.severity || "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(iddesafio);
    } finally {
      setLoading(false);
    }
  };

  const gravarCondicao = async () => {
    if (!sel?.id) return;
    if (!condicaoTargetPatamar?.id) return;
    if (!novaCondicao.idtipocondicao) return showAlert("Indica o tipo de condição.", "warning");
    if (!novaCondicao.idtipooperador) return showAlert("Indica o operador.", "warning");
    if (String(novaCondicao.valor || "").trim() === "")
      return showAlert("Indica o valor.", "warning");

    const isEdit = Number(condicaoEditId || 0) > 0;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post(isEdit ? "Comercial/UpdIncentivoCondicao" : "Comercial/InsIncentivoCondicao", {
          id: condicaoEditId,
          idpatamar: condicaoTargetPatamar.id,
          idtipocondicao: Number(novaCondicao.idtipocondicao),
          idtipooperador: Number(novaCondicao.idtipooperador),
          valor: Number(String(novaCondicao.valor).replace(",", ".")),
          ordem: Number(novaCondicao.ordem || 1),
          obs: novaCondicao.obs?.trim() || null,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Condição gravada.", meta?.severity || "success");

      setOpenCondicao(false);
      setCondicaoEditId(0);
      setNovaCondicao({
        ordem: 1,
        idtipocondicao: "",
        idtipooperador: "",
        valor: "",
        obs: "",
      });

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(condicaoTargetDesafio?.id || null);
      setExpandedPatamar(condicaoTargetPatamar.id);
    } finally {
      setLoading(false);
    }
  };

  const removerCondicao = async (c, p, d) => {
    if (!c?.id) return;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/DelIncentivoCondicao", { id: c.id })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Condição eliminada.", meta?.severity || "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(d?.id || null);
      setExpandedPatamar(p?.id || null);
    } finally {
      setLoading(false);
    }
  };

  const confirmarEstado = async () => {
    if (!target?.id) return;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/InativarIncentivo", {
          id: target.id,
          inativo: novoEstado,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Estado atualizado.", meta?.severity || "success");
      setOpenConfirm(false);
      setTarget(null);
      await carregar();
    } finally {
      setLoading(false);
    }
  };

  const carregarResultados = async (idincentivo) => {
    setLoading(true);
    try {
      const [payload, err] = await handleApi(
        api.post("Comercial/SelIncentivosResultadosVendedores", {
          idincentivo,
          idutilizador: userData?.id || 0,
          funcoes: userData?.funcoes || [],
        })
      );

      if (err) return showAlert(err, "error");

      setResultados(Array.isArray(payload) ? payload : []);
      setOpenResultados(true);
    } finally {
      setLoading(false);
    }
  };

  const abrirResultadoDetalhe = async (r) => {
    setLoading(true);
    try {
      const [payload, err] = await handleApi(
        api.post("Comercial/SelIncentivosResultadoDetalhe", {
          idincentivo: r.idincentivo,
          iddesafio: r.iddesafio,
          idpatamar: r.idpatamar,
          refvendedor: r.refvendedor,
        })
      );

      if (err) {
        showAlert(err, "error");
        return;
      }

      setResultadoDetalhe(Array.isArray(payload) ? payload : []);

      setResultadoDetalheTitulo(`${r.vendedor} · ${r.grupo} · ${r.patamar}`);

      setOpenResultadoDetalhe(true);
    } finally {
      setLoading(false);
    }
  };

  const rowActions = useMemo(
    () => [
      {
        id: "editar",
        icon: <EditIcon fontSize="small" />,
        tooltip: "Editar",
        color: "default",
        visible: () => temPermissao("Menu Comercial", "u"),
        onClick: abrirEdicao,
      },
      {
        id: "resultados",
        icon: <EmojiEventsIcon fontSize="small" />,
        tooltip: "Resultados",
        color: "info",
        visible: () => temPermissao("Menu Comercial", "r"),
        onClick: (r) => carregarResultados(r.id),
      },
      {
        id: "estado",
        icon: (r) =>
          Number(r.inativo || 0) === 1 ? (
            <CheckCircleIcon fontSize="small" />
          ) : (
            <BlockIcon fontSize="small" />
          ),
        tooltip: (r) => (Number(r.inativo || 0) === 1 ? "Reativar" : "Inativar"),
        color: (r) => (Number(r.inativo || 0) === 1 ? "success" : "error"),
        visible: () => temPermissao("Menu Comercial", "d"),
        onClick: (r) => {
          setTarget(r);
          setNovoEstado(Number(r.inativo || 0) === 1 ? 0 : 1);
          setOpenConfirm(true);
        },
      },
    ],
    [temPermissao]
  );

  const columns = useMemo(
    () => [
      { Header: "Nome", accessor: "nome", width: 260 },
      { Header: "Fabricantes", accessor: "fabricante", width: 220 },
      { Header: "Materiais", accessor: "materiais_resumo", width: 360 },
      {
        Header: "Data inicial",
        accessor: "dataini",
        width: 120,
        Cell: ({ value }) => toISODate(value),
      },
      {
        Header: "Data final",
        accessor: "datafim",
        width: 120,
        Cell: ({ value }) => toISODate(value),
      },
      {
        Header: "Observações",
        accessor: "obs",
        width: 260,
      },
      {
        Header: "Estado",
        accessor: "inativo",
        width: 100,
        Cell: ({ value }) => (Number(value || 0) === 1 ? "Inativo" : "Ativo"),
      },
    ],
    []
  );

  const atualizarClientesIncluidos = async (refcliente, incluir) => {
    if (!sel?.id) return;

    const atuais = (doc.clientesExcluidos || [])
      .filter((x) => Number(x.incluido || 0) === 1)
      .map((x) => String(x.refcliente || ""));

    const novos = incluir
      ? Array.from(new Set([...atuais, String(refcliente)]))
      : atuais.filter((x) => x !== String(refcliente));

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/UpdIncentivosClientesIncluidosLote", {
          idincentivo: sel.id,
          refsclientes: novos,
          atualizado_por: userData?.id || null,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Clientes incluídos atualizados.", meta?.severity || "success");

      const clientesExcluidos = await carregarClientesExcluidos(sel.id);
      setDoc((p) => ({ ...p, clientesExcluidos }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageHeader />

      <MDBox pt={1}>
        <ProjectTable
          tableKey="incentivos"
          version="v1"
          columns={columns}
          data={data}
          loading={loading}
          rowActions={rowActions}
          toolbarActions={[
            {
              id: "novo-incentivo",
              label: "Novo Incentivo",
              color: "success",
              disabled: !temPermissao("Menu Comercial", "w"),
              onClick: async () => {
                if (!catalogos) await carregarCatalogos();
                setOpenAdd(true);
              },
            },
          ]}
          minWidth={980}
          maxHeight="68vh"
          emptyMessage="Sem incentivos para apresentar."
          actionsPosition="left"
        />
      </MDBox>

      <Dialog
        open={openAdd}
        onClose={() => setOpenAdd(false)}
        maxWidth="sm"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          Novo Incentivo
        </DialogTitle>
        <DialogContent>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5} mt={1}>
            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Nome"
                value={novo.nome}
                onChange={(e) => setNovo((p) => ({ ...p, nome: e.target.value.toUpperCase() }))}
                fullWidth
              />
            </MDBox>

            <TextField
              label="Data inicial"
              type="date"
              value={novo.dataini}
              onChange={(e) => setNovo((p) => ({ ...p, dataini: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />

            <TextField
              label="Data final"
              type="date"
              value={novo.datafim}
              onChange={(e) => setNovo((p) => ({ ...p, datafim: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />

            <MDInput
              label="Ref. fabricante"
              value={novo.reffabricante}
              onChange={(e) => setNovo((p) => ({ ...p, reffabricante: e.target.value }))}
              fullWidth
            />

            <Autocomplete
              options={catalogos?.funcoes || []}
              value={
                (catalogos?.funcoes || []).find(
                  (x) => Number(x.id) === Number(novo.idfuncaoresponsavel)
                ) || null
              }
              onChange={(_, v) => setNovo((p) => ({ ...p, idfuncaoresponsavel: v?.id || null }))}
              getOptionLabel={(o) => o?.nome || ""}
              isOptionEqualToValue={(opt, val) => Number(opt?.id) === Number(val?.id)}
              renderInput={(params) => (
                <TextField {...params} label="Função responsável" fullWidth />
              )}
            />

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(novo.beneficio_empresa)}
                    onChange={(e) =>
                      setNovo((p) => ({
                        ...p,
                        beneficio_empresa: e.target.checked,
                      }))
                    }
                  />
                }
                label="Benefício pago à empresa"
              />
            </MDBox>

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Observações"
                value={novo.obs}
                onChange={(e) => setNovo((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenAdd(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={inserir} disabled={loading}>
            Inserir
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            width: "96vw",
            maxWidth: "96vw",
            height: "94vh",
            maxHeight: "94vh",
          },
        }}
      >
        <DialogTitle>Editar Incentivo</DialogTitle>
        <DialogContent>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5} mt={1}>
            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Nome"
                value={sel?.nome || ""}
                onChange={(e) => setSel((p) => ({ ...p, nome: e.target.value.toUpperCase() }))}
                fullWidth
              />
            </MDBox>

            <TextField
              label="Data inicial"
              type="date"
              value={sel?.dataini || ""}
              onChange={(e) => setSel((p) => ({ ...p, dataini: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />

            <TextField
              label="Data final"
              type="date"
              value={sel?.datafim || ""}
              onChange={(e) => setSel((p) => ({ ...p, datafim: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />

            <MDInput
              label="Ref. fabricante"
              value={sel?.reffabricante || ""}
              onChange={(e) => setSel((p) => ({ ...p, reffabricante: e.target.value }))}
              fullWidth
            />

            <Autocomplete
              options={catalogos?.funcoes || []}
              value={
                (catalogos?.funcoes || []).find(
                  (x) => Number(x.id) === Number(sel?.idfuncaoresponsavel)
                ) || null
              }
              onChange={(_, v) => setSel((p) => ({ ...p, idfuncaoresponsavel: v?.id || null }))}
              getOptionLabel={(o) => o?.nome || ""}
              isOptionEqualToValue={(opt, val) => Number(opt?.id) === Number(val?.id)}
              renderInput={(params) => (
                <TextField {...params} label="Função responsável" fullWidth />
              )}
            />

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(sel?.beneficio_empresa)}
                    onChange={(e) =>
                      setSel((p) => ({
                        ...p,
                        beneficio_empresa: e.target.checked,
                      }))
                    }
                  />
                }
                label="Benefício pago à empresa"
              />
            </MDBox>

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Observações"
                value={sel?.obs || ""}
                onChange={(e) => setSel((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />
            </MDBox>
          </MDBox>

          <Divider sx={{ my: 2 }} />

          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <MDTypography variant="h6">Grupos</MDTypography>
          </MDBox>

          {(doc.desafios || []).length === 0 && (
            <MDTypography variant="caption" color="text">
              Ainda não existem grupos configurados para este incentivo.
            </MDTypography>
          )}

          {(doc.desafios || []).map((d) => {
            const materiais = (doc.materiais || []).filter(
              (m) => Number(m.iddesafio) === Number(d.id)
            );
            const patamares = (doc.patamares || []).filter(
              (p) => Number(p.iddesafio) === Number(d.id)
            );

            return (
              <Accordion
                key={d.id}
                expanded={expandedDesafio === d.id}
                onChange={(_, isExpanded) => setExpandedDesafio(isExpanded ? d.id : null)}
                disableGutters
                sx={{
                  mb: 1,
                  backgroundColor: "#fff7f0",
                  borderRadius: 2,
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
                  sx={{
                    minHeight: 32,
                    px: 1.5,
                    "& .MuiAccordionSummary-content": { margin: "4px 0" },
                  }}
                >
                  <MDBox display="flex" alignItems="center" width="100%" gap={1.5}>
                    <MDBox display="flex" gap={0.5} onClick={(e) => e.stopPropagation()}>
                      <IconButton color="error" size="small" onClick={() => removerDesafio(d)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </MDBox>

                    <MDBox flex={1}>
                      <MDInput
                        value={d.nome || ""}
                        variant="standard"
                        onClick={(e) => e.stopPropagation()}
                        onFocus={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          const nome = e.target.value.toUpperCase();

                          setDoc((prev) => ({
                            ...prev,
                            desafios: prev.desafios.map((x) =>
                              Number(x.id) === Number(d.id) ? { ...x, nome } : x
                            ),
                          }));
                        }}
                        onBlur={async (e) => {
                          const nome = e.target.value.trim();

                          const [_payload, err] = await handleApi(
                            api.post("Comercial/UpdIncentivoDesafio", {
                              id: d.id,
                              idincentivo: sel.id,
                              nome,
                              ordem: d.ordem,
                              obs: d.obs || null,
                            })
                          );

                          if (err) showAlert(err, "error");
                        }}
                        sx={{
                          minWidth: 260,
                          "& input": {
                            fontWeight: 700,
                            fontSize: "1rem",
                          },
                        }}
                      />
                      <MDTypography variant="caption" color="text" display="block">
                        {materiais.length === 0
                          ? "Sem materiais"
                          : materiais
                              .slice(0, 3)
                              .map((m) => `${m.refmaterial} - ${m.material || ""}`.trim())
                              .join(", ")}

                        {materiais.length > 3 ? ` e mais ${materiais.length - 3}` : ""}
                      </MDTypography>

                      <MDTypography variant="caption" color="text" display="block">
                        {
                          (doc.desafiosRegras || []).filter(
                            (r) => Number(r.iddesafio) === Number(d.id)
                          ).length
                        }{" "}
                        regras · {patamares.length} patamares
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </AccordionSummary>

                <AccordionDetails>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="button" fontWeight="bold">
                      Materiais
                    </MDTypography>

                    <MDButton
                      color="info"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        setMaterialTargetDesafio(d);
                        setNovoMaterial({ refmaterial: "" });
                        setMaterialSel(null);
                        setMateriaisOptions([]);
                        setOpenMaterial(true);
                      }}
                    >
                      + Material
                    </MDButton>
                  </MDBox>

                  <MDBox mt={0.5} mb={1.5}>
                    {materiais.length === 0 ? (
                      <MDTypography variant="caption" color="text">
                        Sem materiais.
                      </MDTypography>
                    ) : (
                      materiais.map((m) => (
                        <MDBox
                          key={m.id}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          gap={1}
                          sx={{
                            borderBottom: "1px solid #f0f0f0",
                            py: 0.5,
                          }}
                        >
                          <MDTypography variant="caption">
                            {m.refmaterial} — {m.material || ""}
                          </MDTypography>

                          <IconButton
                            color="error"
                            size="small"
                            onClick={() => removerMaterial(m, d.id)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </MDBox>
                      ))
                    )}
                  </MDBox>

                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="button" fontWeight="bold">
                      Patamares
                    </MDTypography>

                    <MDButton
                      color="info"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        const tipos = catalogos?.tiposBeneficio || [];
                        setPatamarEditId(0);
                        setPatamarTargetDesafio(d);
                        setNovoPatamar({
                          ordem: patamares.length + 1,
                          descricao: "",
                          idtipobeneficio: tipos?.[0]?.id || "",
                          beneficio: "",
                          beneficio_aplicacao: "FIXO",
                          obs: "",
                        });
                        setOpenPatamar(true);
                      }}
                    >
                      + Patamar
                    </MDButton>
                  </MDBox>

                  <MDBox mt={0.5}>
                    {patamares.length === 0 ? (
                      <MDTypography variant="caption" color="text">
                        Sem patamares.
                      </MDTypography>
                    ) : (
                      patamares.map((p) => {
                        const condicoes = (doc.condicoes || []).filter(
                          (c) => Number(c.idpatamar) === Number(p.id)
                        );

                        return (
                          <Accordion
                            key={p.id}
                            expanded={expandedPatamar === p.id}
                            onChange={(_, isExpanded) =>
                              setExpandedPatamar(isExpanded ? p.id : null)
                            }
                            disableGutters
                            sx={{
                              mb: 1,
                              backgroundColor: "#fff7f0",
                              borderRadius: 2,
                              "&:before": { display: "none" },
                            }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
                              sx={{
                                minHeight: 32,
                                px: 1.5,
                                "& .MuiAccordionSummary-content": { margin: "4px 0" },
                              }}
                            >
                              <MDBox display="flex" gap={0.5} onClick={(e) => e.stopPropagation()}>
                                <IconButton
                                  color="error"
                                  size="small"
                                  onClick={() => removerPatamar(p, d.id)}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </MDBox>

                              <MDBox display="flex" alignItems="center" width="100%" gap={1}>
                                <MDBox flex={1}>
                                  <MDInput
                                    value={p.descricao || `PATAMAR ${p.ordem || ""}`}
                                    variant="standard"
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={(e) => {
                                      const descricao = e.target.value.toUpperCase();

                                      setDoc((prev) => ({
                                        ...prev,
                                        patamares: prev.patamares.map((x) =>
                                          Number(x.id) === Number(p.id) ? { ...x, descricao } : x
                                        ),
                                      }));
                                    }}
                                    onBlur={async (e) => {
                                      const descricao = e.target.value.trim().toUpperCase();

                                      const [_payload, err] = await handleApi(
                                        api.post("Comercial/UpdIncentivoPatamar", {
                                          id: p.id,
                                          iddesafio: d.id,
                                          ordem: p.ordem || 1,
                                          descricao,
                                          idtipobeneficio: p.idtipobeneficio,
                                          beneficio: p.beneficio || null,
                                          beneficio_aplicacao: p.beneficio_aplicacao || "FIXO",
                                          obs: p.obs || null,
                                        })
                                      );

                                      if (err) showAlert(err, "error");
                                    }}
                                    sx={{
                                      minWidth: 180,
                                      "& input": {
                                        fontWeight: 700,
                                        fontSize: "0.875rem",
                                      },
                                    }}
                                  />

                                  <MDTypography variant="caption" color="text" display="block">
                                    {condicoes.length === 0
                                      ? "Sem condições"
                                      : condicoes
                                          .map((c) => {
                                            const nome = c.tipocondicao || "";
                                            const operador = c.operador_codigo || "";
                                            const unidade = c.tipocondicao_unidade || "";

                                            return `${nome} ${operador} ${c.valor}${
                                              unidade ? ` ${unidade}` : ""
                                            }`;
                                          })
                                          .join(" · ")}
                                  </MDTypography>

                                  <MDBox
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <MDTypography variant="caption" color="primary">
                                      ➜
                                    </MDTypography>

                                    <TextField
                                      select
                                      variant="standard"
                                      value={p.idtipobeneficio || ""}
                                      onChange={async (e) => {
                                        const idtipobeneficio = Number(e.target.value || 0);
                                        const tipo = (catalogos?.tiposBeneficio || []).find(
                                          (x) => Number(x.id) === idtipobeneficio
                                        );

                                        setDoc((prev) => ({
                                          ...prev,
                                          patamares: prev.patamares.map((x) =>
                                            Number(x.id) === Number(p.id)
                                              ? {
                                                  ...x,
                                                  idtipobeneficio,
                                                  tipobeneficio: tipo?.codigo || x.tipobeneficio,
                                                  tipobeneficio_nome:
                                                    tipo?.nome || x.tipobeneficio_nome,
                                                  beneficio_aplicacao:
                                                    tipo?.codigo === "VALOR_POR_UNIDADE"
                                                      ? x.beneficio_aplicacao === "EXCEDENTE"
                                                        ? "EXCEDENTE"
                                                        : "POR_UNIDADE"
                                                      : "FIXO",
                                                }
                                              : x
                                          ),
                                        }));

                                        const [_payload, err] = await handleApi(
                                          api.post("Comercial/UpdIncentivoPatamar", {
                                            id: p.id,
                                            iddesafio: d.id,
                                            ordem: p.ordem || 1,
                                            descricao: p.descricao || null,
                                            idtipobeneficio,
                                            beneficio: p.beneficio || null,
                                            beneficio_aplicacao:
                                              tipo?.codigo === "VALOR_POR_UNIDADE"
                                                ? p.beneficio_aplicacao === "EXCEDENTE"
                                                  ? "EXCEDENTE"
                                                  : "POR_UNIDADE"
                                                : "FIXO",
                                            obs: p.obs || null,
                                          })
                                        );

                                        if (err) showAlert(err, "error");
                                      }}
                                      SelectProps={{ native: true }}
                                      sx={{
                                        minWidth: 130,
                                        "& select": { fontSize: "0.75rem" },
                                      }}
                                    >
                                      {(catalogos?.tiposBeneficio || []).map((x) => (
                                        <option key={x.id} value={x.id}>
                                          {x.nome}
                                        </option>
                                      ))}
                                    </TextField>

                                    {p.tipobeneficio === "VALOR_POR_UNIDADE" && (
                                      <TextField
                                        select
                                        variant="standard"
                                        value={p.beneficio_aplicacao || "FIXO"}
                                        onChange={async (e) => {
                                          const beneficio_aplicacao = e.target.value;

                                          setDoc((prev) => ({
                                            ...prev,
                                            patamares: prev.patamares.map((x) =>
                                              Number(x.id) === Number(p.id)
                                                ? { ...x, beneficio_aplicacao }
                                                : x
                                            ),
                                          }));

                                          const [_payload, err] = await handleApi(
                                            api.post("Comercial/UpdIncentivoPatamar", {
                                              id: p.id,
                                              iddesafio: d.id,
                                              ordem: p.ordem || 1,
                                              descricao: p.descricao || null,
                                              idtipobeneficio: p.idtipobeneficio,
                                              beneficio: p.beneficio || null,
                                              beneficio_aplicacao,
                                              obs: p.obs || null,
                                            })
                                          );

                                          if (err) showAlert(err, "error");
                                        }}
                                        SelectProps={{ native: true }}
                                        sx={{
                                          minWidth: 210,
                                          "& select": { fontSize: "0.75rem" },
                                        }}
                                      >
                                        <option value="POR_UNIDADE">Todas as unidades</option>
                                        <option value="EXCEDENTE">
                                          Acima da quantidade mínima
                                        </option>
                                        <option value="PRIMEIRA_COMPRA_CLIENTE_MATERIAL">
                                          Primeira compra por cliente/material
                                        </option>
                                      </TextField>
                                    )}

                                    <MDInput
                                      value={p.beneficio || ""}
                                      variant="standard"
                                      onChange={(e) => {
                                        const beneficio = e.target.value;

                                        setDoc((prev) => ({
                                          ...prev,
                                          patamares: prev.patamares.map((x) =>
                                            Number(x.id) === Number(p.id) ? { ...x, beneficio } : x
                                          ),
                                        }));
                                      }}
                                      onBlur={async (e) => {
                                        const beneficio = e.target.value.trim();

                                        const [_payload, err] = await handleApi(
                                          api.post("Comercial/UpdIncentivoPatamar", {
                                            id: p.id,
                                            iddesafio: d.id,
                                            ordem: p.ordem || 1,
                                            descricao: p.descricao || null,
                                            idtipobeneficio: p.idtipobeneficio,
                                            beneficio,
                                            beneficio_aplicacao: p.beneficio_aplicacao || "FIXO",
                                            obs: p.obs || null,
                                          })
                                        );

                                        if (err) showAlert(err, "error");
                                      }}
                                      sx={{
                                        width: 120,
                                        "& input": { fontSize: "0.75rem" },
                                      }}
                                    />
                                  </MDBox>
                                </MDBox>
                              </MDBox>
                            </AccordionSummary>

                            <AccordionDetails>
                              <MDBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <MDTypography variant="button" fontWeight="bold">
                                  Condições
                                </MDTypography>

                                <MDButton
                                  color="info"
                                  size="small"
                                  startIcon={<AddIcon />}
                                  onClick={() => {
                                    const tiposCond = catalogos?.tiposCondicao || [];
                                    const tiposOp = catalogos?.tiposOperador || [];

                                    setCondicaoEditId(0);
                                    setCondicaoTargetPatamar(p);
                                    setCondicaoTargetDesafio(d);
                                    setNovaCondicao({
                                      ordem: condicoes.length + 1,
                                      idtipocondicao: tiposCond?.[0]?.id || "",
                                      idtipooperador:
                                        tiposOp?.find((x) => x.codigo === ">=")?.id ||
                                        tiposOp?.[0]?.id ||
                                        "",
                                      valor: "",
                                      obs: "",
                                    });
                                    setOpenCondicao(true);
                                  }}
                                >
                                  + Nova condição
                                </MDButton>
                              </MDBox>

                              <MDBox mt={0.5}>
                                {condicoes.length === 0 ? (
                                  <MDTypography variant="caption" color="text">
                                    Sem condições.
                                  </MDTypography>
                                ) : (
                                  condicoes.map((c) => (
                                    <MDBox
                                      key={c.id}
                                      display="flex"
                                      justifyContent="space-between"
                                      alignItems="center"
                                      gap={1}
                                      sx={{
                                        borderBottom: "1px solid #f0f0f0",
                                        py: 0.5,
                                      }}
                                    >
                                      <MDBox
                                        display="grid"
                                        gridTemplateColumns="1fr 80px 100px 80px"
                                        gap={1}
                                        alignItems="center"
                                        flex={1}
                                      >
                                        <TextField
                                          select
                                          variant="standard"
                                          value={c.idtipocondicao || ""}
                                          onClick={(e) => e.stopPropagation()}
                                          onChange={async (e) => {
                                            const idtipocondicao = Number(e.target.value || 0);
                                            const tipo = (catalogos?.tiposCondicao || []).find(
                                              (x) => Number(x.id) === idtipocondicao
                                            );

                                            setDoc((prev) => ({
                                              ...prev,
                                              condicoes: prev.condicoes.map((x) =>
                                                Number(x.id) === Number(c.id)
                                                  ? {
                                                      ...x,
                                                      idtipocondicao,
                                                      tipocondicao: tipo?.nome || x.tipocondicao,
                                                      tipocondicao_codigo:
                                                        tipo?.codigo || x.tipocondicao_codigo,
                                                      tipocondicao_unidade:
                                                        tipo?.unidademedida || "",
                                                    }
                                                  : x
                                              ),
                                            }));

                                            const [_payload, err] = await handleApi(
                                              api.post("Comercial/UpdIncentivoCondicao", {
                                                id: c.id,
                                                idpatamar: p.id,
                                                idtipocondicao,
                                                idtipooperador: c.idtipooperador,
                                                valor: Number(
                                                  String(c.valor || "0").replace(",", ".")
                                                ),
                                                ordem: c.ordem || 1,
                                                obs: c.obs || null,
                                              })
                                            );

                                            if (err) showAlert(err, "error");
                                          }}
                                          SelectProps={{ native: true }}
                                          sx={{
                                            minWidth: 160,
                                            "& select": {
                                              fontSize: "0.75rem",
                                            },
                                          }}
                                        >
                                          {(catalogos?.tiposCondicao || []).map((x) => (
                                            <option key={x.id} value={x.id}>
                                              {x.nome}
                                            </option>
                                          ))}
                                        </TextField>

                                        <TextField
                                          select
                                          variant="standard"
                                          value={c.idtipooperador || ""}
                                          onClick={(e) => e.stopPropagation()}
                                          onChange={async (e) => {
                                            const idtipooperador = Number(e.target.value || 0);
                                            const op = (catalogos?.tiposOperador || []).find(
                                              (x) => Number(x.id) === idtipooperador
                                            );

                                            setDoc((prev) => ({
                                              ...prev,
                                              condicoes: prev.condicoes.map((x) =>
                                                Number(x.id) === Number(c.id)
                                                  ? {
                                                      ...x,
                                                      idtipooperador,
                                                      operador_codigo:
                                                        op?.codigo || x.operador_codigo,
                                                      operador: op?.nome || x.operador,
                                                    }
                                                  : x
                                              ),
                                            }));

                                            const [_payload, err] = await handleApi(
                                              api.post("Comercial/UpdIncentivoCondicao", {
                                                id: c.id,
                                                idpatamar: p.id,
                                                idtipocondicao: c.idtipocondicao,
                                                idtipooperador,
                                                valor: Number(
                                                  String(c.valor || "0").replace(",", ".")
                                                ),
                                                ordem: c.ordem || 1,
                                                obs: c.obs || null,
                                              })
                                            );

                                            if (err) showAlert(err, "error");
                                          }}
                                          SelectProps={{ native: true }}
                                          sx={{
                                            width: 70,
                                            "& select": {
                                              fontSize: "0.75rem",
                                            },
                                          }}
                                        >
                                          {(catalogos?.tiposOperador || []).map((x) => (
                                            <option key={x.id} value={x.id}>
                                              {x.codigo}
                                            </option>
                                          ))}
                                        </TextField>

                                        <MDInput
                                          value={c.valor ?? ""}
                                          variant="standard"
                                          onClick={(e) => e.stopPropagation()}
                                          onChange={(e) => {
                                            const valor = e.target.value;

                                            setDoc((prev) => ({
                                              ...prev,
                                              condicoes: prev.condicoes.map((x) =>
                                                Number(x.id) === Number(c.id) ? { ...x, valor } : x
                                              ),
                                            }));
                                          }}
                                          onBlur={async (e) => {
                                            const valor = String(e.target.value || "").replace(
                                              ",",
                                              "."
                                            );

                                            if (valor.trim() === "")
                                              return showAlert("Indica o valor.", "warning");

                                            const [_payload, err] = await handleApi(
                                              api.post("Comercial/UpdIncentivoCondicao", {
                                                id: c.id,
                                                idpatamar: p.id,
                                                idtipocondicao: c.idtipocondicao,
                                                idtipooperador: c.idtipooperador,
                                                valor: Number(valor),
                                                ordem: c.ordem || 1,
                                                obs: c.obs || null,
                                              })
                                            );

                                            if (err) showAlert(err, "error");
                                          }}
                                          sx={{
                                            width: 80,
                                            "& input": {
                                              fontSize: "0.75rem",
                                            },
                                          }}
                                        />

                                        <MDTypography variant="caption">
                                          {c.tipocondicao_unidade || ""}
                                        </MDTypography>
                                      </MDBox>

                                      <MDBox display="flex" gap={0.5}>
                                        <IconButton
                                          color="error"
                                          size="small"
                                          onClick={() => removerCondicao(c, p, d)}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </MDBox>
                                    </MDBox>
                                  ))
                                )}
                              </MDBox>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })
                    )}
                  </MDBox>

                  <MDBox mb={1.5}>
                    <MDTypography variant="button" fontWeight="bold">
                      Regras de avaliação
                    </MDTypography>

                    <MDBox display="flex" flexWrap="wrap" gap={1} mt={0.5}>
                      {(catalogos?.tiposDesafio || []).map((regra) => {
                        const checked = (doc.desafiosRegras || []).some(
                          (r) =>
                            Number(r.iddesafio) === Number(d.id) &&
                            Number(r.idtipodesafio) === Number(regra.id)
                        );

                        return (
                          <FormControlLabel
                            key={regra.id}
                            control={
                              <Checkbox
                                size="small"
                                checked={checked}
                                onChange={(e) => toggleRegraDesafio(d, regra.id, e.target.checked)}
                              />
                            }
                            label={regra.nome}
                          />
                        );
                      })}
                    </MDBox>
                  </MDBox>
                </AccordionDetails>
              </Accordion>
            );
          })}

          <Divider sx={{ my: 2 }} />

          <Accordion disableGutters sx={{ mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <MDTypography variant="h6">Clientes excluídos por acordos/descontos</MDTypography>
            </AccordionSummary>

            <AccordionDetails>
              {(doc.clientesExcluidos || []).length === 0 ? (
                <MDTypography variant="caption" color="text">
                  Sem clientes excluídos automaticamente.
                </MDTypography>
              ) : (
                <MDBox display="grid" gap={0.5}>
                  {(doc.clientesExcluidos || []).map((c) => (
                    <MDBox
                      key={`${c.refcliente}-${c.origem}-${c.reffabricante}`}
                      display="grid"
                      gridTemplateColumns="140px 1fr 220px 220px"
                      gap={1}
                      alignItems="center"
                      sx={{ borderBottom: "1px solid #eee", py: 0.5 }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={Number(c.incluido || 0) === 1}
                            onChange={(e) =>
                              atualizarClientesIncluidos(c.refcliente, e.target.checked)
                            }
                          />
                        }
                        label="Incluir"
                      />

                      <MDTypography variant="caption">
                        {c.cliente || c.refcliente} ({c.refcliente})
                      </MDTypography>

                      <MDTypography variant="caption">
                        {c.fabricante || c.reffabricante || ""}
                      </MDTypography>

                      <MDTypography variant="caption" color="text">
                        {c.acordo || c.origem || ""}
                      </MDTypography>
                    </MDBox>
                  ))}
                </MDBox>
              )}
            </AccordionDetails>
          </Accordion>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <MDButton color="info" size="small" startIcon={<AddIcon />} onClick={criarGrupoRapido}>
            Novo grupo
          </MDButton>

          <MDBox>
            <MDButton color="secondary" onClick={() => setOpenEdit(false)}>
              Cancelar
            </MDButton>

            <MDButton color="success" onClick={gravarEdicao} disabled={loading}>
              Guardar
            </MDButton>
          </MDBox>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDesafio}
        onClose={() => setOpenDesafio(false)}
        maxWidth="sm"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          {desafioEditId ? "Editar grupo" : "Novo grupo"}
        </DialogTitle>
        <DialogContent>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5} mt={1}>
            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Nome"
                value={novoDesafio.nome}
                onChange={(e) =>
                  setNovoDesafio((p) => ({ ...p, nome: e.target.value.toUpperCase() }))
                }
                fullWidth
              />
            </MDBox>

            <TextField
              label="Ordem"
              type="number"
              value={novoDesafio.ordem}
              onChange={(e) => setNovoDesafio((p) => ({ ...p, ordem: e.target.value }))}
              fullWidth
            />

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Observações"
                value={novoDesafio.obs}
                onChange={(e) => setNovoDesafio((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenDesafio(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={gravarDesafio} disabled={loading}>
            {desafioEditId ? "Guardar" : "Inserir"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openMaterial}
        onClose={() => setOpenMaterial(false)}
        maxWidth="xs"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          Adicionar material
        </DialogTitle>
        <DialogContent>
          <MDBox mt={1}>
            <Autocomplete
              options={materiaisOptions}
              filterOptions={(x) => x}
              value={materialSel}
              onChange={(_, v) => {
                setMaterialSel(v);
                setNovoMaterial({ refmaterial: v?.ref || "" });
              }}
              onInputChange={(_, v) => pesquisarMateriais(v)}
              getOptionLabel={(o) => (o?.nome ? `${o.nome} (${o.ref})` : o?.ref || "")}
              isOptionEqualToValue={(opt, val) => String(opt?.ref || "") === String(val?.ref || "")}
              renderInput={(params) => (
                <TextField {...params} label="Material" size="small" fullWidth />
              )}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenMaterial(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={adicionarMaterial} disabled={loading}>
            Inserir
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPatamar}
        onClose={() => setOpenPatamar(false)}
        maxWidth="sm"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          {patamarEditId ? "Editar patamar" : "Novo patamar"}
        </DialogTitle>
        <DialogContent>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5} mt={1}>
            <TextField
              label="Ordem"
              type="number"
              value={novoPatamar.ordem}
              onChange={(e) => setNovoPatamar((p) => ({ ...p, ordem: e.target.value }))}
              fullWidth
            />

            <TextField
              select
              label="Tipo de benefício"
              value={novoPatamar.idtipobeneficio}
              onChange={(e) => {
                const idtipobeneficio = e.target.value;
                const tipo = (catalogos?.tiposBeneficio || []).find(
                  (x) => Number(x.id) === Number(idtipobeneficio)
                );

                setNovoPatamar((p) => ({
                  ...p,
                  idtipobeneficio,
                  beneficio_aplicacao:
                    tipo?.codigo === "VALOR_POR_UNIDADE" ? "POR_UNIDADE" : "FIXO",
                }));
              }}
              SelectProps={{ native: true }}
              fullWidth
            >
              <option value="">(Selecionar)</option>
              {(catalogos?.tiposBeneficio || []).map((x) => (
                <option key={x.id} value={x.id}>
                  {x.nome}
                </option>
              ))}
            </TextField>

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Descrição"
                value={novoPatamar.descricao}
                onChange={(e) =>
                  setNovoPatamar((p) => ({ ...p, descricao: e.target.value.toUpperCase() }))
                }
                fullWidth
              />
            </MDBox>

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Benefício"
                value={novoPatamar.beneficio}
                onChange={(e) => setNovoPatamar((p) => ({ ...p, beneficio: e.target.value }))}
                fullWidth
              />
            </MDBox>

            {(catalogos?.tiposBeneficio || []).find(
              (x) => Number(x.id) === Number(novoPatamar.idtipobeneficio)
            )?.codigo === "VALOR_POR_UNIDADE" && (
              <TextField
                select
                label="Aplicar benefício"
                value={novoPatamar.beneficio_aplicacao}
                onChange={(e) =>
                  setNovoPatamar((p) => ({
                    ...p,
                    beneficio_aplicacao: e.target.value,
                  }))
                }
                SelectProps={{ native: true }}
                fullWidth
              >
                <option value="POR_UNIDADE">Todas as unidades</option>
                <option value="EXCEDENTE">Apenas às unidades acima da quantidade mínima</option>
                <option value="PRIMEIRA_COMPRA_CLIENTE_MATERIAL">
                  Apenas na primeira compra por cliente/material
                </option>
              </TextField>
            )}

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Observações"
                value={novoPatamar.obs}
                onChange={(e) => setNovoPatamar((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenPatamar(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={gravarPatamar} disabled={loading}>
            {patamarEditId ? "Guardar" : "Inserir"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCondicao}
        onClose={() => setOpenCondicao(false)}
        maxWidth="sm"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          {condicaoEditId ? "Editar condição" : "Nova condição"}
        </DialogTitle>
        <DialogContent>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5} mt={1}>
            <TextField
              label="Ordem"
              type="number"
              value={novaCondicao.ordem}
              onChange={(e) => setNovaCondicao((p) => ({ ...p, ordem: e.target.value }))}
              fullWidth
            />

            <TextField
              select
              label="Tipo de condição"
              value={novaCondicao.idtipocondicao}
              onChange={(e) => setNovaCondicao((p) => ({ ...p, idtipocondicao: e.target.value }))}
              SelectProps={{ native: true }}
              fullWidth
            >
              <option value="">(Selecionar)</option>
              {(catalogos?.tiposCondicao || []).map((x) => (
                <option key={x.id} value={x.id}>
                  {x.nome}
                </option>
              ))}
            </TextField>

            <TextField
              select
              label="Operador"
              value={novaCondicao.idtipooperador}
              onChange={(e) => setNovaCondicao((p) => ({ ...p, idtipooperador: e.target.value }))}
              SelectProps={{ native: true }}
              fullWidth
            >
              <option value="">(Selecionar)</option>
              {(catalogos?.tiposOperador || []).map((x) => (
                <option key={x.id} value={x.id}>
                  {x.nome}
                </option>
              ))}
            </TextField>

            <MDInput
              label="Valor"
              value={novaCondicao.valor}
              onChange={(e) => setNovaCondicao((p) => ({ ...p, valor: e.target.value }))}
              fullWidth
            />

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Observações"
                value={novaCondicao.obs}
                onChange={(e) => setNovaCondicao((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenCondicao(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={gravarCondicao} disabled={loading}>
            {condicaoEditId ? "Guardar" : "Inserir"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        maxWidth="xs"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          {novoEstado === 1 ? "Inativar incentivo" : "Reativar incentivo"}
        </DialogTitle>
        <DialogContent>
          {novoEstado === 1 ? "Inativar" : "Reativar"} o incentivo{" "}
          <strong>{target?.nome || ""}</strong>?
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenConfirm(false)}>
            Cancelar
          </MDButton>
          <MDButton color={novoEstado === 1 ? "error" : "success"} onClick={confirmarEstado}>
            {novoEstado === 1 ? "Inativar" : "Reativar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openResultados}
        onClose={() => setOpenResultados(false)}
        maxWidth="xl"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          Resultados do incentivo
        </DialogTitle>

        <DialogContent>
          <ProjectTable
            tableKey="incentivos-resultados"
            version="v1"
            columns={[
              { Header: "Vendedor", accessor: "vendedor", width: 220 },
              { Header: "Incentivo", accessor: "incentivo", width: 200 },
              { Header: "Grupo", accessor: "grupo", width: 150 },
              { Header: "Patamar", accessor: "patamar", width: 150 },
              { Header: "Condições necessárias", accessor: "condicoes", width: 360 },
              {
                Header: "Prémio",
                accessor: "beneficio_descricao",
                width: 320,
              },
              { Header: "Faturação", accessor: "obtido", width: 300 },
              {
                Header: "Estado",
                accessor: "atingido",
                width: 120,
                Cell: ({ value }) => (value ? "Atingido" : "Não atingido"),
              },
              {
                Header: "Prémio alcançado",
                accessor: "beneficio_obtido",
                width: 160,
                Cell: ({ value }) => value || "",
              },
            ]}
            data={resultados}
            loading={loading}
            rowActions={[
              {
                id: "detalhe",
                icon: <InfoOutlinedIcon fontSize="small" />,
                tooltip: "Ver clientes e faturas",
                color: "info",
                onClick: abrirResultadoDetalhe,
              },
            ]}
            minWidth={1820}
            maxHeight="58vh"
            emptyMessage="Sem resultados para apresentar."
            actionsPosition="left"
          />
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenResultados(false)}>
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openResultadoDetalhe}
        onClose={() => setOpenResultadoDetalhe(false)}
        maxWidth="xl"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          Detalhe do resultado
        </DialogTitle>

        <DialogContent>
          <MDTypography variant="caption" color="text" display="block" mb={1}>
            {resultadoDetalheTitulo}
          </MDTypography>

          <ProjectTable
            tableKey="incentivos-resultados-detalhe"
            version="v1"
            columns={[
              {
                Header: "Data",
                accessor: "faturadata",
                width: 110,
                Cell: ({ value }) => toISODate(value),
              },
              { Header: "Fatura", accessor: "faturanumero", width: 130 },
              { Header: "Cliente", accessor: "cliente", width: 260 },
              { Header: "Material", accessor: "material", width: 320 },
              { Header: "Qtd", accessor: "qtd", width: 90 },
              { Header: "€ Líquido", accessor: "precoliquido", width: 110 },
              {
                Header: "1ª Compra",
                accessor: "primeira_compra",
                width: 110,
                Cell: ({ value }) => (Number(value || 0) === 1 ? "✓" : ""),
              },
              {
                Header: "Entra benefício",
                accessor: "entra_beneficio",
                width: 130,
                Cell: ({ value }) => (Number(value || 0) === 1 ? "✓" : ""),
              },
            ]}
            data={resultadoDetalhe}
            loading={loading}
            minWidth={1260}
            maxHeight="58vh"
            emptyMessage="Sem faturas para apresentar."
            actionsPosition="left"
          />
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenResultadoDetalhe(false)}>
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}
